import { CEOrganizationBase } from './ce-organization-base'


export class CEOrganization extends CEOrganizationBase {

}